import React, { useState } from 'react';
import { apiClient } from '../../components/api/ApiClient';
import JSZip from 'jszip';

function MoadianFilesModal({ isVisible, onClose }) {
    const [loading, setLoading] = useState(false);
    const [fileData, setFileData] = useState(null);
    const [error, setError] = useState(null);

    const handleFetchFiles = async () => {
        setLoading(true);
        setError(null);
        try {
            const response = await apiClient('/companies/api/create-moadian-files/', {
                method: 'GET'
            });
            setFileData(response);
        } catch (err) {
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    React.useEffect(() => {
        if (isVisible) {
            handleFetchFiles();
        } else {
            setFileData(null);
            setError(null);
        }
    }, [isVisible]);

    const handleDownload = () => {
        if (fileData && fileData.private_key && fileData.csr) {
            const zip = new JSZip();
            zip.file("private_key.key", fileData.private_key);
            zip.file("request.csr", fileData.csr);

            zip.generateAsync({type: "blob"}).then((content) => {
                const url = URL.createObjectURL(content);
                const a = document.createElement("a");
                a.href = url;
                a.download = "moadian-files.zip";
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
                URL.revokeObjectURL(url);
            });
        }
    };

    if (!isVisible) return null;

    return (
        <div className="modal fade show d-block" tabIndex="-1" style={{ backgroundColor: 'rgba(0,0,0,0.5)' }}>
            <div className="modal-dialog modal-dialog-centered">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title">تولید فایل درخواست گواهی</h5>
                        <button type="button" className="btn-close" onClick={onClose}></button>
                    </div>
                    <div className="modal-body text-center">
                        {loading ? (
                            <div className="py-5">
                                <div className="spinner-border text-primary" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <div className="mt-3">در حال دریافت اطلاعات...</div>
                            </div>
                        ) : error ? (
                            <div className="alert alert-danger">{error}</div>
                        ) : fileData ? (
                            <div>
                                <div className="bg-primary text-white p-3 rounded mb-4">
                                    <strong>فایل کلید خصوصی , CSR</strong>
                                </div>
                                <p className="text-muted mb-2">
                                    فایل کلید خصوصی برای رمز گذاری صورتحساب برای ارسال به سامانه مودیان مورد استفاده قرار میگیرد
                                </p>
                                <p className="text-muted mb-4">
                                    فایل CSR برای تولید فایل سرتیفیکیت مورد استفاده قرار میگیرد
                                </p>
                                <button className="btn btn-primary w-100" onClick={handleDownload}>
                                    دانلود
                                </button>
                            </div>
                        ) : (
                            <div className="py-4 text-muted">در حال بارگذاری...</div>
                        )}
                    </div>
                    <div className="modal-footer justify-content-center">
                        <button type="button" className="btn btn-secondary" onClick={onClose}>بستن</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MoadianFilesModal;
